import React, { useEffect, useState } from 'react';
import { Select, SelectOption } from 'tea-component';
import { useIntl } from 'umi';
import classnames from 'classnames';

interface ISingleCommonSelectorProps {
  className?: string;
  style?: React.CSSProperties;
  buttonTitle: React.ReactNode;
  value: string;
  options: SelectOption[];
  handleClick: (value: string) => void;
  buttonFomat?: (option: SelectOption) => React.ReactNode;
}

export default function SingleCommonSelector(
  props: ISingleCommonSelectorProps,
) {
  const {
    className,
    style,
    buttonTitle,
    value: defaultValue,
    options,
    handleClick,
    buttonFomat,
  } = props;
  const { formatMessage } = useIntl();
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const defaultButtonFomat = (option: SelectOption) => (
    <div className="dbi-select-button">
      <div className="select-button-text">{buttonTitle}</div>
      {option?.text ? (
        <span className="select-button-desc">{option.text}</span>
      ) : (
        <span className="select-button-placeholder">
          {formatMessage({ id: 'dbi_please_select' })}
        </span>
      )}
    </div>
  );

  return (
    <Select
      className={classnames('select-item', className)}
      style={style}
      appearance="button"
      options={options}
      value={value}
      listHeight={234}
      matchButtonWidth
      onChange={(value) => {
        setValue(value);
        if (handleClick instanceof Function) {
          handleClick(value);
        }
      }}
      button={
        buttonFomat instanceof Function ? buttonFomat : defaultButtonFomat
      }
    />
  );
}
